<template>
  <div class="pages">
    <navTop :acIndex="4"></navTop>
    <div class="box" v-html="detail"></div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
export default {
  name: "about",
  components: {
    navTop,
    navFooter,
  },
  data() {
    return {
      detail: "",
    };
  },
  created() {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({path: "/"});
    } else {
      this.getAgreement();
    }
  },
  methods: {
    getAgreement() {
      this.$api.agreement({type: 0}).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.detail = res.data.detail;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    margin: 30px auto 80px;
    max-width: 1400px;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;

    border: 1px solid $blue-primary-rgba;
    border-radius: 20px;
    padding: 40px;
    background: rgba(15, 43, 63, 0.6);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 30px $blue-glow;

    ::v-deep p {
      font-size: 18px;
      color: #c0e4ff;
      line-height: 1.8;
      margin-bottom: 15px;
      text-shadow: 0 0 5px $blue-glow;

      &:last-child {
        margin-bottom: 0;
      }
    }

    ::v-deep h1, ::v-deep h2, ::v-deep h3, ::v-deep h4 {
      color: $blue-primary;
      text-shadow: $text-glow;
      margin-bottom: 20px;
      font-weight: bold;
    }

    ::v-deep h1 {
      font-size: 28px;
    }

    ::v-deep h2 {
      font-size: 24px;
    }

    ::v-deep h3 {
      font-size: 20px;
    }

    ::v-deep a {
      color: $blue-primary;
      text-decoration: none;
      border-bottom: 1px solid $blue-primary;
      transition: all 0.3s ease;

      &:hover {
        color: lighten($blue-primary, 15%);
        border-bottom-color: lighten($blue-primary, 15%);
      }
    }

    ::v-deep img {
      width: 100%;
      display: block;
      border-radius: 8px;
      margin: 20px 0;
      box-shadow: 0 0 20px $blue-glow;
    }

    ::v-deep ul, ::v-deep ol {
      padding-left: 20px;
      margin-bottom: 15px;

      li {
        color: #c0e4ff;
        font-size: 16px;
        line-height: 1.6;
        margin-bottom: 5px;
      }
    }

    ::v-deep strong, ::v-deep b {
      color: $blue-primary;
    }

    ::v-deep blockquote {
      border-left: 3px solid $blue-primary;
      padding-left: 20px;
      margin: 20px 0;
      color: #a0c4e0;
      font-style: italic;
    }

    ::v-deep table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;

      th, td {
        border: 1px solid $blue-primary-rgba;
        padding: 10px;
        color: #c0e4ff;
      }

      th {
        background: rgba(27, 168, 232, 0.2);
        color: $blue-primary;
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding: 30px;

      ::v-deep p {
        font-size: 16px;
      }

      ::v-deep h1 {
        font-size: 24px;
      }

      ::v-deep h2 {
        font-size: 20px;
      }

      ::v-deep h3 {
        font-size: 18px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      padding: 20px;
      margin: 20px auto 60px;

      ::v-deep p {
        font-size: 14px;
        line-height: 1.6;
      }

      ::v-deep h1 {
        font-size: 20px;
      }

      ::v-deep h2 {
        font-size: 18px;
      }

      ::v-deep h3 {
        font-size: 16px;
      }
    }
  }
}
</style>